
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8">
        <div class="search-area-div">月份：</div>
          <el-date-picker
            v-model="monthList"
            type="monthrange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>
         </el-col>
        <el-col :span="8">
        <div class="search-area-div">公司：</div>
            <el-select v-model="page.tenantGuid" placeholder="请选择" class="ipt-sty" filterable >
            <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
         </el-col>
        <el-col :span="8" class="t-right">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add()">新增信息推广费通知</el-button>
      <el-button size="medium" type="danger" @click="update">修改推广费通知</el-button>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table :data="performanceData" style="width: 100%;margin-bottom: 20px;" border v-loading="tableLoading">
        <!-- <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column> -->
        <el-table-column label="序号" width="60" header-align="center" align="center">
                <template slot-scope="scope">
                    {{scope.$index+1}} 
                </template>
        </el-table-column>
        <el-table-column prop="month" label="月份" sortable header-align="center" align="left"> </el-table-column>
        <el-table-column prop="batchNum" label="批次/编号" header-align="center" align="left"> </el-table-column>
        <el-table-column prop="tenantName" label="企业" min-width="150" show-overflow-tooltip header-align="center" align="left"> </el-table-column>
        <el-table-column prop="totalAmount" label="推广费总额(元)" width="130" show-overflow-tooltip  header-align="center" align="right">
              <template slot-scope="scope">{{scope.row.totalAmount | numDigit | numFmt}}</template>
        </el-table-column>
        <el-table-column prop="sendNoticeNum" label="已通知"  header-align="center" align="right">
                <template slot-scope="scope">{{scope.row.sendNoticeNum==null?'0':scope.row.sendNoticeNum}}</template>
        </el-table-column>
        <el-table-column prop="reportOrgNum" label="已提报" header-align="center" align="right">
                <template slot-scope="scope">
                            <div class="fontC-green" v-if="scope.row.reportOrgNum == scope.row.sendNoticeNum">{{scope.row.reportOrgNum==null?'0':scope.row.reportOrgNum}}</div>
                            <div v-else>{{scope.row.reportOrgNum==null?'0':scope.row.reportOrgNum}}</div>
                </template>
        </el-table-column>
        <el-table-column prop="approvalOrgNum" label="已审核" header-align="center" align="right"> 
                 <template slot-scope="scope">
                            <div class="fontC-green" v-if="scope.row.approvalOrgNum == scope.row.sendNoticeNum">{{scope.row.approvalOrgNum==null?'0':scope.row.approvalOrgNum}}</div>
                            <div v-else>{{scope.row.approvalOrgNum==null?'0':scope.row.approvalOrgNum}}</div>
                 </template>
        </el-table-column>
        <el-table-column prop="approvalState" label="推广费审批" header-align="center" align="left">
              <template slot-scope="scope">
                    <div class="fontC-green" v-if="scope.row.approvalState == 'Y'">{{scope.row.approvalState | approvalState}}</div>
                    <div class="fontC-red" v-if="scope.row.approvalState == 'R'">{{scope.row.approvalState | approvalState}}</div>
                    <div v-if="scope.row.approvalState == 'N' || scope.row.approvalState == 'A'">{{scope.row.approvalState | approvalState}}</div>
              </template>
        </el-table-column>
        <el-table-column prop="performancePayState" label="推广费发放" header-align="center" align="left">
              <template slot-scope="scope">
                    <div class="fontC-green" v-if="scope.row.performancePayState == 'Y'">{{scope.row.performancePayState | performancePayState}}</div>
                    <div v-else>{{scope.row.performancePayState | performancePayState}}</div>
              </template>
        </el-table-column>
        <el-table-column prop="noticeTime" label="通知时间" sortable header-align="center" align="left"> 
              <template slot-scope="scope">{{scope.row.noticeTime | getDate}}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="toDetail(scope.row.guid)">详情</a> 
          </template>
        </el-table-column>
      </el-table> 
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="新增信息推广费通知" :visible.sync="dialogFormVisible" width="1300px">
      <div class="t-left mt15 h40">
          <p class="fl" style="font-weight:bold;font-size:16px;">查询条件过滤</p> 
      </div>
      <div style="display:flex;width:100%">
        <div style="display:flex;margin-right:40px;">
          <div class="search-area-div">*企业:</div> 
            <el-select v-model="tenantGuid" placeholder="请选择" class="ipt-sty" filterable @change="getManageStaff(tenantGuid)">
                 <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
              </el-option >
            </el-select>
        </div> 
         <div style="display:flex;margin-right:40px;">
            <div class="search-area-div">组织名称:</div>
            <el-input v-model="organisationName" class="ipt-sty" placeholder="请输入组织名称"></el-input>
        </div> 
        <div style="display:flex">
          <div class="search-area-div">核算单元:</div>
          <el-select v-model="bizUnitGuid" placeholder="请选择">
            <el-option
              v-for="item in bizUnitNameOptions"
              :key="item.guid"
              :label="item.label"
              :value="item.guid">
            </el-option>
          </el-select>
        </div>
        <div style="display:flex;margin-left:40px;">
          <el-button size="medium" type="info" @click="searchStaff">搜索</el-button>
          <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
        </div>
      </div>
       <div class="t-left mt15 h40">
          <p class="fl" style="font-weight:bold;font-size:16px;">基本信息录入</p> 
      </div>
       <div style="display:flex;width:100%">
        <div style="display:flex;margin-right:40px;">
          <div class="search-area-div">*月份:</div>
            <el-date-picker v-model="month" type="month" placeholder="选择月份" class="ipt-sty"></el-date-picker>
        </div> 
        <div style="display:flex">
            <div class="search-area-div">*推广费总额:</div>
            <el-input v-model="totalAmount" class="ipt-sty" placeholder="请输入推广费总额"></el-input>
        </div>  
      </div> 
      <div class="t-left mt15 h40">
            <p class="fl" style="font-weight:bold;font-size:16px;">推广费信息（默认展示所有省总）</p> 
            <p class="fr">已录入提报金额：<b class="font-S16 fontC-4fa1a4">{{sum | numDigit | numFmt}}</b>元</p> 
      </div>
      <div class="t-left h170" v-if="uploadSh"> 
            <div class="mt15">下载模板：<el-button plain size="medium" @click="uploadExcel">下载文件模板</el-button></div>
            <div class="mt15 mt15 h90"><p class="fl">导入文件：</p>
            <!-- <el-button size="medium" type="info" @click="add(1, '')">点击上传文件</el-button> -->
                  <el-upload
                    class="upload-demo fl"
                    action="#"  
                    :before-upload="beforeUpload"
                    multiple
                    :limit="1"
                    accept=".xlsx,.xsl,.xls,.xlsm"
                    :auto-upload="false"
                    :on-change="changeFile"
                    :on-exceed="handleExceed">
                    <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading">点击上传文件</el-button>
                    <div slot="tip" class="el-upload__tip">
                    当前仅支持 excel 格式文件（大小在5M以内），请使用 Office 2010 及以上版本，否则可能出现乱码<br>
                    必须严格按照模板内容填入数据，否则可能会出现导入异常
                    </div>
                  </el-upload>
            </div> 
      </div> 
      <el-table ref="table" :data="performanceReportsList" border style="width: 100%;" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope"> 
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="人员" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="mobileNo" label="手机" header-align="center" align="center"></el-table-column>
        <el-table-column prop="organisationGuid" label="组织(只到省区)" header-align="center" align="left">
              <template slot-scope="scope">
                <el-select v-model="scope.row.organisationGuid" placeholder="请选择"  v-if="scope.row.organisationRelList != null && scope.row.organisationRelList.length > 1" >
                  <el-option
                    v-for="item in scope.row.organisationRelList"
                    :key="item.organisationGuid"
                    :label="item.organisationName" 
                    :value="item.organisationGuid">
                  </el-option>
                </el-select> 
                <div v-else class="pl16 fl">{{scope.row.organisationName}}</div>
              </template>
        </el-table-column>
        <el-table-column prop="positionNames" label="岗位" header-align="center" align="center">
              <template slot-scope="scope">{{scope.row.positionNames | roleNames}}</template>
        </el-table-column> 
        <el-table-column prop="performanceAmount" label="提报金额(元)" header-align="center" align="center">
          <template slot-scope="scope">
             <el-input-number v-model="scope.row.performanceAmount" :precision="2" :step="100" class="w80f t-right" placeholder="请输入" @change="achievement()" :min="0.00"></el-input-number>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="deleteRow(scope.$index,performanceReportsList,scope.row.guid)">删除</a> 
          </template>
        </el-table-column> -->
      </el-table> 
      <!-- <div class="mt15"><a class="txt-color" @click="addRow()">+ 添加</a> </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="submit">确定</el-button>
      </div>
    </el-dialog>  
  </div>
</template>

<script>
import {route}  from '@/api/apiRoute';
import citys from '../../components/citys.vue';
export default {
    components:{
    citys,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
          console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      }; 
    return {
      url:`/${serverConfig.msCommonAdminCloudService}/excel/import/get-performance?tenantGuid=`+this.$store.state.guid,
      value2:'',
      performanceData:[],
      monthList:'',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        startMonth: '',
        endMonth: '',
        tenantGuid:''
      },
      fullscreenLoading: false,
      dialogFormVisible: false,
      currentManageStaff:[],
      tenantList:[],
      tenantGuid:'',
      month:'',
      totalAmount:'',
      performanceReportsList:'',
      multipleSelection:'', 
      sum:0,
      tableLoading:false,
      uploadSh:false,

      bizUnitNameOptions:[],
      organisationName:'',
      bizUnitGuid:""
    };
  },
  created() {
    // 列表 

    this.getTenant();
    // this.getSuperiorOrganization();
   
  },
  methods: {
    getbizUnitNameOptions() {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: 1000,
        tenantGuid: self.tenantGuid 
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/get-biz-unit`, page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
         var list = res.data.data.records;
         self.bizUnitNameOptions = list
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
     uploadExcel(){ 
              window.open('/获取推广费上报数据.xlsx');
     },
     beforeUpload(file) {
            let filename = file.name
            let arr = filename.split('.')
            if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
              this.$message.error('上传文件只能是 excel/xls 格式!')
              return false
            }
            return arr
      },
    handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
    changeFile(file,fileList) {
           let self = this; 
           let isLt5M = file.size / 1024 / 1024 < 5
           if (!isLt5M) {
                  self.$message.error('上传文件大小不能超过 5MB')
                  file = null
                  fileList = [];
                  self.$refs.upload.clearFiles() // 清除前端显示的文件列表
            }else{
                  self.fullscreenLoading = true;
                  let formData = new FormData();
                  formData.append('file',file.raw);//传文件
                  self.api.postFile(self.url,formData).then(function(res){  
                    console.log(res.data);
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                      self.$message({
                        type: 'success',
                        message: '上传成功'
                      })  
                      self.fullscreenLoading = false;
                      self.performanceReportsList.forEach(i=>{ 
                              res.data.data.forEach(j=>{ 
                                    if(i.mobileNo == j.mobileNo && i.staffName == j.staffName){
                                            i.performanceAmount = j.amount
                                    }
                              })
                      })
                      self.achievement();
                    } else {
                      self.$message({
                        type: 'warning',
                        message: '数据格式不正确！'
                      })
                      self.fullscreenLoading = false;
                      return false
                    }
                  })
            } 
      },
    empty() {
      let self = this;
      self.monthList = [];
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        startMonth: '',
        endMonth: '',
        tenantGuid:''
      };
        if(self.tenantList != null && self.tenantList.length > 0){
            self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
          }
      self.getData(true);
    },
    achievement(index,myAmount){
          let self = this; 
          self.sum = 0; 
          self.performanceReportsList.forEach(function(i){
                if(parseInt(i.performanceAmount) > 0){
                      self.sum += i.performanceAmount
                }  
          })
          if(self.sum > self.totalAmount){
                self.$message.error("提报金额之和不能大于推广费总额");
                // self.performanceReportsList[index].performanceAmount = '0'; 
          }
    },
    deleteRow(index, rows,guid) {
      let self = this;
      if(guid != null && guid != ''){
          self.removeGuids.push(guid);
      }
        rows.splice(index, 1); 
    },
    update(){
        let self = this;
        self.$message("敬请期待");
    },
    addRow(){
          let self = this;
          let item = {
              achievementStaffGuid: '',
              myAmount: 0,
              achievementRatio: 0,
              totalAchievementRatio: 0,
              guid:''
          }
          self.performanceReportsList.push(item);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if(self.monthList && Array.isArray(self.monthList) && self.monthList.length > 0){
        self.page.startMonth = self.$moment(self.monthList[0]).format('YYYYMM');
        self.page.endMonth = self.$moment(self.monthList[1]).format('YYYYMM');
      }else{
        self.page.startMonth = '';
        self.page.endMonth = '';
      } 
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/performance/data/get-performance-list`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          self.tableLoading = false;
          self.performanceData = res.data.data.records; 
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    add() {
      let self = this; 
      self.tenantGuid = '';
      self.organisationName = '';
      self.bizUnitGuid = '';
      self.dialogFormVisible = true;
      self.uploadSh = false;
      self.performanceReportsList = [];
    },
    getManageStaff(tenantGuid) { 
      let self = this;
      self.uploadSh = true;
      self.tenantGuid = tenantGuid;
      this.getbizUnitNameOptions();
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get-province-manager`,{tenantGuid}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.performanceReportsList = res.data.data.records;
          if(self.performanceReportsList.length >0){
                self.performanceReportsList.forEach(function(i){
                        if(i.organisationRelList != null && i.organisationRelList.length == 1){
                                i.organisationName = i.organisationRelList[0].organisationName
                        }
                })
          }
          self.performanceReportsList.forEach(function(i){
                    self.$nextTick(()=> {
                            self.$refs.table.toggleRowSelection(i);
                    })
          }) 
        } else {
          self.$message.error(res.data.msg);
          self.performanceReportsList = [];
        }
      });
    },
    searchStaff(){
      var self = this;
      if(this.tenantGuid==''){
        this.$message.error('请先选择企业');
        return
      }
      var tenantGuid = self.tenantGuid;
      var organisationName = self.organisationName;
      var bizUnitGuid = self.bizUnitGuid;
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get-province-manager`,{tenantGuid,organisationName,bizUnitGuid}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.performanceReportsList = res.data.data.records;
          if(self.performanceReportsList.length >0){
                self.performanceReportsList.forEach(function(i){
                        if(i.organisationRelList != null && i.organisationRelList.length == 1){
                                i.organisationName = i.organisationRelList[0].organisationName
                        }
                })
          }
          self.performanceReportsList.forEach(function(i){
                    self.$nextTick(()=> {
                            self.$refs.table.toggleRowSelection(i);
                    })
          }) 
        } else {
          self.$message.error(res.data.msg);
          self.performanceReportsList = [];
        }
      });
    },
    emptySearch(){
      this.organisationName = "";
      this.bizUnitGuid = "";
     
      this.getManageStaff(this.tenantGuid)
    },
    getTenant() { 
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
          if(self.tenantList != null && self.tenantList.length > 0){
            // self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
            // self.page.tenantGuid = '3d3861e610cb40218d3ecf641147affd';//测试
            self.page.tenantGuid = '37a58d7a80ae11ebafd0fa163e4b37cf';//正式
          }
          self.getData(false);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
   handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    submit() {
          let self = this;   
          let performanceReports = [];
          if(self.multipleSelection.length == 0){
                self.$message.error("请勾选需要提报的数据！");
                return
          }
          if(!self.month){
                self.$message.error("请选择月份！");
                return
          }
          if(!self.totalAmount){
                self.$message.error("请输入推广费总额！");
                return
          }
          var sum = 0;
          self.multipleSelection.forEach(function(i){
                if(parseInt(i.performanceAmount) > 0){
                      sum += i.performanceAmount
                }  
          })
          if(sum > self.totalAmount){
                self.$message.error("提报金额之和不能大于推广费总额");
                return
          }
          for(var i = 0; i < self.multipleSelection.length; i++){
                if(self.multipleSelection[i].performanceAmount > 0){
                    let item = {
                      staffGuid:self.multipleSelection[i].guid,
                      staffName:self.multipleSelection[i].staffName,
                      performanceAmount:self.multipleSelection[i].performanceAmount,
                      organisationGuid:self.multipleSelection[i].organisationGuid
                  }
                  performanceReports.push(item); 
                }else{
                  self.$message.error(self.multipleSelection[i].staffName +"提报金额必须大于0！");
                  return
                } 
          } 
          var month = self.$moment(self.month).format('YYYYMM');
          let promise = {
            tenantGuid: self.tenantGuid,
            month: month,
            totalAmount: self.totalAmount,
            performanceReports: performanceReports,
            operateTenantGuid:localStorage.guid
          };
          self.$confirm('请确定各个省区的"提报金额"准确无误?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              self.api.postJson(`/${serverConfig.msSalesPerformService}/performance/data/add`, promise).then(res => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.dialogFormVisible = false;
                  self.$message.success('下发推广费通知成功');
                  self.getData(true); 
                } else {
                  self.$message.error(res.data.msg);
                }
              }); 
        })
      },
      toDetail(guid){
          this.$router.push({path: "/performanceReporting/detail", query:{   productGuid:this.$route.query.productGuid,guid:guid}})
    },

  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
     height: 40px; 
     line-height: 40px; 
} 
.el-col-6{
    width: 33%;
   
  }
</style>